import { keepPreviousData, useQuery } from "@tanstack/react-query";

import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import { retryQueryOnUnauthorizedError, throwOnUnhandledError } from "app/pages/sales-intelligence/query/utils";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type {
    ContactsResponseDto,
    ContactsSearchResultsRequestDto,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

import { contactsQueryKeys } from "../queryKeys/queryKeyFactory";

function useContactsSearchResultsQuery<T = ContactsResponseDto>(
    enabled: boolean,
    leadType: LeadsType,
    dto: ContactsSearchResultsRequestDto,
    throwOnError: boolean | ((error: unknown) => boolean) = throwOnUnhandledError,
    select?: (data: ContactsResponseDto) => T,
) {
    return useQuery<ContactsResponseDto, unknown, T>({
        enabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: contactsQueryKeys.tableData(leadType, dto),
        placeholderData: keepPreviousData,
        throwOnError,
        select,
        retry: retryQueryOnUnauthorizedError,
        queryFn({ signal }) {
            return salesApiService.contactsSearch.fetchSearchResults(leadType, dto, {
                cancellation: signal,
            });
        },
    });
}

export default useContactsSearchResultsQuery;
